import { useReducer, useState } from "react";
import { DialogActions, DialogContent, TextField, Typography } from "@mui/material";
import { Button } from "@mui/material";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { DialogTitle } from "@mui/material";
import { Grid } from "@mui/material";
import { MenuItem } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { IconButton } from "@mui/material";
import { pos_create } from "../../../../../../controllers/company/cashless/PosController";
import QUDProgress from "../../../../../../components/progress";
import ResponseComponent from "../../../../../../components/responseComponent";


const initialState = {
    name:'',    errorName:false,
    type:'',    errorType: false,
    email:'',   errorEmail: false,
    pin:'',     errorPin: false,

    isLoading: false,

    open: false,
    title: '',
    message: '',
    success: false
}
  
function reducer( state, { field, value })
{
    return{
        ...state,
        [field] : value
    }
}

export default function CashlessEconomyPOSCreate({economy,participants,onUpdate})
{
    const [openDialog,setOpenOpenDialog] = useState(false);
    const [state,setState] = useReducer(reducer,initialState);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const {
        name, type, email,
        errorName, errorType, errorEmail,
        pin, errorPin,
        isLoading,
        
        open,
        title,
        message,
        success
    } = state;

    const onChange = (e) => {
        setState({field : e.target.name, value : e.target.value});
    }

    const handleToggleDialogForm = () => {
        setOpenOpenDialog(!openDialog);
    }

    const handleClose = () => {
        setState({field: 'type', value: ''});
        setState({field: 'name', value: ''});
        setState({field: 'email', value: ''});
        setState({field: 'errorType', value: false});
        setState({field: 'errorName', value: false});
        setState({field: 'errorEmail', value: false});

        handleToggleDialogForm();
    }

    const handleSubmit = async () => {
        setState({field:'isLoading',value: true});

        const response = await pos_create(economy.id,email,name,type,pin);

        if(response.success === true)
        {
            setState({field:'title',value:'Operación Exitosa'});
            setState({field:'message',value:response.message.message});
            setState({field:'success',value:true});
            setState({field:'open',value:true});
        }
        else
        {
            setState({field:'title',value:'Operación Fallida'});
            setState({field:'message',value:response.message.message});
            setState({field:'success',value:false});
            setState({field:'open',value:true});
        }

        setState({field:'isLoading',value: false});
    }

    const onClose = () => {
        setState({field:'open',value:false});
        handleClose();
        onUpdate();
    }
    
    return(
        <>
            <Button variant="contained" onClick={()=>handleToggleDialogForm()}>
                <Typography>Agregar POS</Typography>
            </Button>

            <Dialog
                open={openDialog}
                onClose={()=>handleClose()}
                fullScreen={fullScreen}
            >
                <DialogTitle id="responsive-dialog-title">
                    Crear POS
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={()=>handleClose()}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <FontAwesomeIcon icon={faClose}/>
                </IconButton>
                <DialogContent>
                    <Grid container spacing={3}>
                        {/**Type */}
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                                fullWidth
                                select
                                id="type"
                                name='type'
                                label="Tipo de POS"
                                variant="outlined"
                                value = {type}
                                onChange = { onChange }
                                onBlur={ () => setState({field:'errorType',value:type === ''}) }
                                error = {errorType}
                                helperText={errorType && <Typography>Selecciona el tipo de POS</Typography>}
                            >
                                <MenuItem value=''>Selecciona el tipo de POS</MenuItem>
                                <MenuItem value='admin'>Administrador</MenuItem>
                                <MenuItem value='recharge'>Recarga</MenuItem>
                                <MenuItem value='business_admin'>Comercio</MenuItem>
                                <MenuItem value='cashier'>Cajero</MenuItem>
                            </TextField>
                        </Grid>

                        {/**POS Name */}
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                                fullWidth
                                label='Nombre del POS'
                                name='name'
                                id='name'
                                required
                                value={name}
                                onChange = { onChange }
                                onBlur={ () => setState({field:'errorName',value:name === ''}) }
                                error = {errorName}
                                helperText={errorName && <Typography>Ingrese el nombre de la economia</Typography>}
                            />
                        </Grid>
                        
                        {/**merchant email */}
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                                fullWidth
                                select
                                id="type"
                                name='email'
                                label="Participante"
                                variant="outlined"
                                value = {email}
                                onChange = { onChange }
                                onBlur={ () => setState({field:'errorEmail',value:email === ''}) }
                                error = {errorEmail}
                                helperText={errorEmail && <Typography>Ingrese el nombre de la economia</Typography>}
                            >
                                <MenuItem value=''>Selecciona un participante</MenuItem>
                                {
                                    participants &&
                                    participants.map(item=>
                                        <MenuItem value={item.entity.email}>{item.entity.name}</MenuItem>
                                    )
                                }
                                
                            </TextField>
                        </Grid>

                        {/**pin */}
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                                fullWidth
                                label='PIN de Seguridad'
                                name='pin'
                                id='pin'
                                required
                                value={pin}
                                onChange = { onChange }
                                onBlur={ () => setState({field:'errorPin',value:pin === ''}) }
                                error = {errorPin}
                                helperText={errorPin && <Typography>Ingrese el PIN de seguridad del POS</Typography>}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{pr:3}}>
                    <Button onClick={()=>handleToggleDialogForm()}>
                        <Typography>Cancelar</Typography>
                    </Button>
                    <Button variant="contained" onClick={()=>handleSubmit()}>
                        <Typography>Crear POS</Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={open}
                success={success}
                title={title}
                message={message}
                actionText={'Finalizar'}
                onClick={()=>onClose()}
                //secondaryText={'No'}
                ///secondaryAction={()=>history.push('/categories')}
            />
        </>
    )
}